import React from 'react';
import { AgentButton } from 'global-components-library';
import { USER_STATE } from '../../constants.js'
import { getCurrentTimeInSec } from '../helpers/Utils/formats.js';

export const STRATEGIES_PREVIEW_TRANSFER = {
    "GetAnswerTransfer": function (message, that){
        const maxTime = 30000;
        const maxTimeMessage = maxTime + 100;
        const clear = setTimeout(() => {
            that.props.addToast(that.language.getText('CallControlGUICallTransfermissed-xfer-mssg').replace('[N]', message.mainAgent), { 
                title: that.language.getText('CallControlGUICallTransfermissed-xfer-title'),
                group: 'icon',
                position: 'topRight',  
                icon: '', 
                color: 'blue',
                btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>,
                timeout: 5000,
            });
        }, maxTimeMessage);
        that.props.showAlertModal({
            type: "ModalAlert",
            title: that.language.getText("GUIAlertTransfertitle"),
            message: that.language.getText("GUIAlertTransfermessage").replace('[N]', message.mainAgent),
            button: that.language.getText("GUIAlertTransferdeny"),
            secondButton: that.language.getText("GUIAlertTransferadmit"),
            timeout: maxTime,
            timeoutFun: () => {
                that.props.actionResponseTransfer(message.mainAgent, 0);
            },
            secondButtonFtn: () => {
                if(!that.props.preview.simultaneosRecs){
                    let time = getCurrentTimeInSec();
                    let previewTime =  time - that.props.preview.initialTimeSec + that.props.preview.totalPreviewTime;
                    if( that.props.userState.currentState === USER_STATE.AGENT_PREVIEW){
                        that.props.actionPreviewRecord(
                            { 
                                process:4,
                                camId:that.props.preview.camId,
                                callOutId:that.props.preview.callOutId,
                                previewTime:previewTime,
                                callId:0
                            })
                    }
                } else
                {
                    that.props.setUnnasignByXfer({flag:true, mainAgent: message.mainAgent});
                }
                if(!that.props.preview.simultaneosRecs || (that.props.preview.simultaneosRecs && that.props.preview.records.length === 0))
                {
                    setTimeout(() => {that.props.cleanData()},100);
                    setTimeout(() => {that.props.showPreviewData(false)},100);
                    setTimeout(() => {that.props.actionResponseTransfer(message.mainAgent, 1)},100);
                }
                clearTimeout(clear);
            },
            buttonFun: () => {
                that.props.actionResponseTransfer(message.mainAgent, 0) 
                clearTimeout(clear);
            },
            
        });

        
    },
    "SendAnswerTransfer": function(message, that){
        let msg='';
        let titleAlert='';
        if(message.answerTransfer !== 1){
            that.props.showAlert();
            switch(message.answerTransfer){
                case 0:
                    msg = that.language.getText("GUIAlertTransferagentRejected").replace('[N]', message.username);
                    titleAlert = that.language.getText("GUIAlertTransferrejectedTitle");
                    that.props.assistedErrorTransfer(true);
                    break;
                case 2:
                    msg = that.language.getText("GUIAlertTransferagentSwitchedError");
                    titleAlert = that.language.getText("GUIAlertTransfertransferError");
                    break;
                case 4:
                    msg = that.language.getText("GUIAlertTransferagentBusy");
                    titleAlert = that.language.getText("GUIAlertTransfertransferError");
                    break;
                default:
                    msg = that.language.getText("GUIAlertTransferunexpectedError");
                    titleAlert = that.language.getText("GUIAlertTransfertransferError");
                    break;
            }
            
            that.props.addToast(msg, {
                group: 'icon',
                position: 'topRight',
                title: titleAlert,
                color: 'red',
                btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertTransferclose")}</AgentButton>,
                timeout: 5000,
                onDismiss: that.props.showAlert()
            });

            that.props.onAcceptedTransfer(false);
            that.props.setTransferInProgress(false);
        }
        else{
            that.props.onAcceptedTransfer(true);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_Preview_Transfer.js